import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { selectToken } from "src/redux/reducers/authSlice";

const ProtectedRoute = () => {
  const token = useSelector(selectToken);
  return token ? <Outlet/> : <Navigate to="/notFound" />;
};

export default ProtectedRoute;
